import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import { onDisconnect, set, ref as dbRef, serverTimestamp } from 'firebase/database';
import { auth, database } from '@/firebase';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");

const setupPresenceTracking = (uid) => {
    const userStatusRef = dbRef(database, `presence/${uid}`);
    set(userStatusRef, {
        state: 'online',
        last_changed: serverTimestamp()
    });

    onDisconnect(userStatusRef).set({
        state: 'offline',
        last_changed: serverTimestamp()
    });
};

auth.onAuthStateChanged((user) => {
    if (user) {
        setupPresenceTracking(user.uid);
    }
});
